import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, SwiperOptions } from 'swiper';
import { register } from 'swiper/element';
import { AuthService, BlockAbstractComponent, Block, ParserService, ZoneService } from '@gallaghercp/core-frontend';
import { APP_CONFIG } from '@core-app/app.config';

@Component({
    selector: 'core-block-home-hero-banner',
    standalone: false,
    templateUrl: './block-home-hero-banner.component.html',
    styles: [
        `
            .swiper-container:not(.swiper-initialized) {
                opacity: 0;
                transition: opacity 0.3s ease-in-out;
            }

            .swiper-container.swiper-initialized {
                opacity: 1;
            }
        `,
    ],
})
export class BlockHomeHeroBannerComponent extends BlockAbstractComponent implements OnInit, AfterViewInit {
    protected override parser: ParserService;
    protected override auth: AuthService;
    protected breakpoint = inject(BreakpointObserver);
    private sanitizer = inject(DomSanitizer);
    private zoneService = inject(ZoneService);

    @ViewChild('homeBannerSwiper', { static: false }) homeBannerSwiper: any;

    backgroundImage!: string;
    swiperConfig!: SwiperOptions;
    isMobileNav = false;
    h1Heading: string = APP_CONFIG.appName;
    isCarouselDotsPositionOnLeft: boolean = false;

    constructor() {
        const parser = inject(ParserService);
        const auth = inject(AuthService);

        super(parser, auth);

        this.parser = parser;
        this.auth = auth;
    }

    override ngOnInit() {
        super.ngOnInit();

        // Initialise Swiper modules if in browser environment
        if (this.isBrowser) {
            SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay]);
        }

        this.backgroundImage = this.block.data.image_url;
        this.swiperConfig = {
            autoplay: false,
            effect: 'slide',
            loop: false,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-home-next',
                prevEl: '.swiper-button-home-prev',
            },
            pagination: {
                el: '.swiper-pagination-home',
                clickable: true,
                bulletActiveClass: 'swiper-pagination-bullet--active',
            },
            slidesPerView: 1,
        };

        // Option to position dots on left side of carousel check but only when hero banner isn't full width
        if (this.block.data.options?.isDotsPositionLeft) {
            this.isCarouselDotsPositionOnLeft =
                this.block.data.options?.isDotsPositionLeft &&
                this.block.data.isCarousel &&
                this.block.data.isNotFullWidth
                    ? this.block.data.options?.isDotsPositionLeft
                    : false;
        }

        this.block.content.map((block: Block) => {
            if (block.data.link && block.data.link.includes('https://')) {
                block.data.targetAttr = 1;
            }
            if (block.data.link && block.data.targetAttr !== 1) {
                block.data.link = this.zoneService.injectZoneCodeUrl(block.data.link);
            }
            return block;
        });

        // Only observe breakpoints in browser environment
        if (this.isBrowser) {
            this.subscriptions.push(
                this.breakpoint.observe(['(max-width: 991px)']).subscribe(result => {
                    this.isMobileNav = result.matches;
                }),
            );
        }
    }

    getBackground(url: string): SafeStyle {
        if (url && !url.includes('https://')) {
            url = APP_CONFIG.frontend + url;
        }
        return this.sanitizer.bypassSecurityTrustStyle('url(' + url + ')');
    }

    ngAfterViewInit(): void {
        // Check if we're in a browser environment before registering Swiper
        if (!this.isBrowser) return;
        register();
    }
}
